import { ReactNode } from "react";

export const inputClass =
  "w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 py-2.5 text-base sm:text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 transition";

export const selectClass =
  "w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 py-2.5 text-base sm:text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 transition appearance-none";

export function Field({
  label,
  htmlFor,
  required,
  children,
}: {
  label: string;
  htmlFor: string;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <div>
      <label htmlFor={htmlFor} className="block text-xs font-medium text-gray-700 mb-1.5">
        {label} {required && <span className="text-brand-600">*</span>}
      </label>
      {children}
    </div>
  );
}

/** Off-screen field people never see. Bots that fill it are dropped by the API. */
export function Honeypot() {
  return (
    <div aria-hidden="true" className="absolute -left-[9999px] w-px h-px overflow-hidden">
      <label htmlFor="hp">Leave this field empty</label>
      <input id="hp" name="hp" type="text" tabIndex={-1} autoComplete="off" />
    </div>
  );
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3.5 py-2.5">
      {message}
    </p>
  );
}

export function SubmitButton({ pending, children }: { pending: boolean; children: ReactNode }) {
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full bg-brand-900 hover:bg-brand-800 disabled:opacity-60 disabled:hover:translate-y-0 text-white font-medium py-3.5 rounded-full transition-all shadow-md shadow-brand-900/20 hover:shadow-lg hover:-translate-y-0.5 cursor-pointer disabled:cursor-wait"
    >
      {pending ? "Sending..." : children}
    </button>
  );
}

export function SuccessState({ title, message, children }: { title: string; message?: string; children?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center h-full py-16 text-center">
      <div className="w-16 h-16 rounded-full bg-brand-900/10 flex items-center justify-center mb-5">
        <svg className="w-8 h-8 text-brand-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-2xl font-display font-semibold text-gray-900 mb-2 max-w-sm">{title}</h3>
      {message && <p className="text-gray-500 max-w-xs leading-relaxed">{message}</p>}
      {children}
    </div>
  );
}

export function PreferEmail() {
  return (
    <p className="text-xs text-center text-gray-400">
      Prefer email?{" "}
      <a href="mailto:adam@fitted.co" className="text-brand-600 hover:underline cursor-pointer">
        adam@fitted.co
      </a>
    </p>
  );
}
